import { css, keyframes } from '@emotion/react'
import styled from '@emotion/styled'

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`

const sizeMap = {
  small: 20,
  medium: 40,
  large: 60,
}

export const SpinnerWrapper = styled.div<{ size: 'small' | 'medium' | 'large' }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;

  ${({ size }) => css`
    width: ${sizeMap[size]}px;
    height: ${sizeMap[size]}px;
  `}

  svg {
    width: 100%;
    height: 100%;
    animation: ${spin} 1s linear infinite;
  }
`
